<template>
    <div class="af" >
        <div class="flex w100 marT10">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input  @clear="clearsearch('sou')" prefix-icon="el-icon-search" class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('button_search_for')" clearable size="mini"></el-input>
            <el-button class="marB10" icon="el-icon-search" circle @click="gosearch()" size="mini" ></el-button>
            <el-button :type="activeC=='over'?'primary':'default'" class="marB10"  @click="gosearch('over')" size="mini" >{{$t('paymentApplication_display_all')}}</el-button>
        </div>
        <el-table
                ref="table"
                size="mini"
                border
                :data="tableData"
                height="380"
                style="width: 100%"
                class="marT10"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow"
                @selection-change="handleSelectionChange"
                @select="handleSelect"
                :row-key="getRowKeys"
                >
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    :label="$t('form_order_number')"
                    show-overflow-tooltip
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('paymentApplication_sales_order_number')"
                    show-overflow-tooltip
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    width="190">
                <template slot-scope="scope">
                    <span>{{scope.row.vc_pzname+'/'+scope.row.vc_bzstyle+'/'+scope.row.vc_cd+'/'+scope.row.vc_gykh}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_fyfstime"
                    :label="$t('paymentApplication_time_of_expense_occurrence')" align="right"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('paymentApplication_order_quantity')" align="right"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
            <el-table-column
                    v-if="i_khtype==2"
                    prop="f_inbound_quantity"
                    :label="$t('paymentApplication_quantity_in_stock')" align="right"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_price" align="right"
                    :label="$t('paymentApplication_order_unit_price')"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_je"
                    :label="$t('paymentApplication_total_order_amount')" align="right"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_sqpay"
                    :label="$t('paymentApplication_the_amount_applied_for_this_time')" align="right"
                    show-overflow-tooltip
                    width="116">
                <template slot-scope="scope">
                    <el-input-number  @change="infsl(tableData,scope.$index,scope.row)"   :controls="false" :min="0" :precision="2" class="changeinput" size="mini" v-model="scope.row.f_sqpay" ></el-input-number>
                </template>
                <!--:disabled="i_khtype==2?false:true" 0716注掉都可以改-->
            </el-table-column>
            <el-table-column
                    prop="f_sqpay"
                    :label="$t('paymentApplication_proportion')" align="right"
                    show-overflow-tooltip
                    width="80">
                <template slot-scope="scope">
                    <span>{{scope.row.nowbl}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_sqpay_total" align="right"
                    :label="$t('paymentApplication_total_applied_amount')"
                    show-overflow-tooltip
                    width="116">
            </el-table-column>
            <el-table-column
                    prop="f_sqpay_total"
                    :label="$t('paymentApplication_total_proportion')" align="right"
                    show-overflow-tooltip
                    width="80">
                <template slot-scope="scope">
                    <span>{{scope.row.totalbl}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_cguname"
                    :label="$t('paymentApplication_procuring_entity')"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[15, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {

        },
        props:{
            orderDetails:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                baseerp:"",
                mid:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                vc_search:"",
                //vc_fkey:"",
                //compsData:[],
                //companyName:'',
                //companyId:0,
                //vc_gscreditcode:"",
                //kpfData:[],
                //i_kpkhid:0,
                //vc_kpkhname:'',
                //vc_khcreditcode:"",
                //fpType:[],
                //i_type:0,
                i_khtype:0,
                //i_issd:0,
                //vc_type:"",
                tableData:[],
                getRowKeys(row){
                    return row.i_pdid
                },
                multipleSelection:[],
                highlightCurrentRow:false,
                backapplys:[],
                delarr:[],
                // tableId:0,
                i_over:0,
                activeC:'unover',
            }
        },
        mounted() {
            ////console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.i_khtype=this.orderDetails.i_khtype;
            this.getfMou();
            this.backapplys=JSON.parse(JSON.stringify(this.orderDetails.applys));
            //console.log('this.backapplys',this.backapplys)
        },
        methods:{
            toPercentage(num) {
                let num2 = this.keepTwoDecimal(num*100);
                return `${num2}%`;
                //return `${(num * 100).toFixed(2)}%`;
            },
            infsl(data,index,row){
                let totalsq = parseFloat(row.f_sqpay) + parseFloat(row.f_sqpay_total);
                let totalbl = this.preciseDiv(totalsq,  parseFloat(row.f_je));
                //console.log('totalbl1',totalbl);
                    totalbl = parseFloat(this.keepTwoDecimal(totalbl));
                //console.log('totalbl2',totalbl);
                    totalbl = this.toPercentage(totalbl);
                //console.log('totalsq',totalsq);
                //console.log('totalbl3',totalbl);
                let nowbl =  this.preciseDiv(parseFloat(row.f_sqpay),  parseFloat(row.f_je));
                //console.log('f_sqpay',parseFloat(row.f_sqpay),'f_je', parseFloat(row.f_je));
                //console.log('nowbl1',nowbl);
                    nowbl = parseFloat(nowbl);
                //console.log('nowbl2',nowbl);
                    nowbl = this.toPercentage(nowbl);
                //console.log('nowbl3',nowbl);
                row.totalbl = totalbl;
                row.nowbl = nowbl;
                this.$set(data,index,row);
                const idx = this.backapplys.findIndex(item => item.i_pdid === row.i_pdid);
                if (idx >= 0) this.$set(this.backapplys, idx, { ...row });
            } ,
            //除
            preciseDiv(dividend, divisor) {
                ////console.log("?????????????")
                if(dividend&&divisor){
                    //console.log("////")
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    ////console.log(result,'result------')
                    // 返回结果，注意这里需要再除以100，因为我们之前乘以了100
                    return result ;
                    /*// 将所有数转换为字符串，以便进行高精度计算
                    a = String(a);
                    b = String(b);
                    // 计算小数点位数
                    const aDecimalIndex = a.indexOf('.');
                    const bDecimalIndex = b.indexOf('.');
                    const aDecimalLength = aDecimalIndex === -1 ? 0 : a.length - aDecimalIndex - 1;
                    const bDecimalLength = bDecimalIndex === -1 ? 0 : b.length - bDecimalIndex - 1;
                    // 对于没有小数部分的数，可以直接使用乘法来模拟除法
                    if (bDecimalIndex === -1) {
                        return Number(a.replace('.', '')) / Number(b);
                    }
                    // 对于有小数部分的数，需要保留足够的小数位参与计算
                    const scale = Math.pow(10, Math.max(aDecimalLength, bDecimalLength));
                    const result = (Number(a.replace('.', '')) / Number(b.replace('.', ''))) * scale;
                    //console.log(scale,result)
                    // 返回结果时再还原小数点和正确的小数位数
                    return result / scale;*/
                }
            },
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 10000) / 10000;//保留两位
                }
                return result;
            },
            //列表fkmxlist
            async getList(type){
                this.loading=true;
                let param={
                    'i_mid':this.mid,
                    //'i_khtype':this.orderDetails.i_okhtype?this.orderDetails.i_okhtype:this.orderDetails.i_khtype,
                    'i_khid':this.orderDetails.i_khid,
                    'i_okhid':this.orderDetails.i_okhid,
                    'i_gsid':this.orderDetails.i_gsid,
                    'i_fktype':this.orderDetails.i_fktype,
                    'vc_fymxs':this.orderDetails.vc_fymxs,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    //'dt_startdate':'2023-01-01',
                    //'dt_enddate':'2024-12-31',
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'i_bzid':this.orderDetails.i_bzid,
                    'i_over':this.i_over,
                    'i_over_pay':this.i_over,
                };
                var res = await API.fkmxlist(param);
                if (res.code==1){
                    res.data.list.map((item)=>{
                        item.totalbl=this.toPercentage(item.f_bl_total);
                        item.nowbl=0;
                    });
                    this.tableData=res.data.list;

                    this.$nextTick(()=>{
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                const isSelected = this.backapplys.some(sel => sel.i_pdid == row.i_pdid);
                                table.toggleRowSelection(row, isSelected);
                                const idx = this.backapplys.findIndex(i => i.i_pdid === row.i_pdid)
                                if(idx!=-1&&isSelected){
                                    //console.log(row,'row',idx,'idx')
                                    row.f_sqpay=this.backapplys[idx].f_sqpay
                                    let nowbl =  this.preciseDiv(parseFloat(this.backapplys[idx].f_sqpay),  parseFloat(this.backapplys[idx].f_je));
                                    nowbl = parseFloat(nowbl);
                                    nowbl = this.toPercentage(nowbl);
                                    row.nowbl = nowbl;
                                    let totalsq = parseFloat(this.backapplys[idx].f_sqpay) + parseFloat(this.backapplys[idx].f_sqpay_total);
                                    let totalbl = this.preciseDiv(totalsq,  parseFloat(this.backapplys[idx].f_je));
                                    totalbl = this.toPercentage(parseFloat(this.keepTwoDecimal(totalbl)));
                                    row.totalbl = totalbl;
                                }

                            })
                        }
                    })

                    /*let iList=[];
                    for(let i=0;i<this.tableData.length;i++){
                        let sg=this.tableData[i];
                        for (let j =0;j<this.backapplys.length;j++){
                            let pz=this.backapplys[j]
                            //console.log(sg,pz)

                            if(sg.i_pdid==pz.i_pdid){
                                iList.push(i)
                                this.tableData[i].f_sqpay=pz.f_sqpay
                                let nowbl =  this.preciseDiv(parseFloat(this.tableData[i].f_sqpay),  parseFloat(this.tableData[i].f_je));
                                nowbl = parseFloat(nowbl);
                                nowbl = this.toPercentage(nowbl);
                                this.tableData[i].nowbl = nowbl;
                            }

                        }
                    }
                    this.$nextTick(()=>{
                        console.log(iList,'iList')
                        for(let i of iList){

                            this.$refs.table.toggleRowSelection(this.tableData[i],true)
                        }

                    });*/
                    this.tableTotal=res.data.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSelect(selection,row){
                let idx = this.tableData.findIndex(item => item===row);
                //console.log('idx',idx)
                this.tableData[idx].f_sqpay = parseFloat(this.tableData[idx].f_je) - parseFloat(this.tableData[idx].f_sqpay_total);
                let totalsq = parseFloat(this.tableData[idx].f_sqpay) + parseFloat(this.tableData[idx].f_sqpay_total);
                //console.log('totalsq',totalsq);
                let totalbl = this.preciseDiv(totalsq,  parseFloat(this.tableData[idx].f_je));
                //console.log('totalbl',totalbl);
                    totalbl = this.toPercentage(parseFloat(this.keepTwoDecimal(totalbl)));
                //console.log('totalbl2',totalbl);
                let nowbl =  this.preciseDiv(parseFloat(this.tableData[idx].f_sqpay),  parseFloat(this.tableData[idx].f_je));
                //console.log('nowbl',nowbl);
                    nowbl = this.toPercentage(parseFloat(this.keepTwoDecimal(nowbl)));
                //console.log('nowbl2',nowbl);
                this.tableData[idx].totalbl = totalbl;
                this.tableData[idx].nowbl = nowbl;

                let obj = selection.find(item => item.i_pdid===row.i_pdid);
                if(obj){
                    if (!this.backapplys.some(item => item.i_pdid === row.i_pdid)) {
                        this.backapplys.push({ ...row });
                    }
                }else{
                    row.f_sqpay=0;
                    row.nowbl=0;
                    let totalsq = parseFloat(this.tableData[idx].f_sqpay) + parseFloat(this.tableData[idx].f_sqpay_total);
                    let totalbl = this.preciseDiv(totalsq,  parseFloat(this.tableData[idx].f_je));
                    totalbl = this.toPercentage(parseFloat(this.keepTwoDecimal(totalbl)));
                    row.totalbl = totalbl;
                    this.backapplys = this.backapplys.filter(item => item.i_pdid !== row.i_pdid);
                    this.delarr.push(row.i_pdid)
                }
                /*if(obj==undefined){
                    this.delarr.push(row.i_pdid)
                }*/
                //console.log(this.delarr,row,obj,'delarr')

            },
            handleSelectionChange:function(val,index) {
                this.multipleSelection = val;
                //console.log(val);

            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            gosearch(type=null){
                //console.log("type",type)
                if(type){
                    this.activeC = this.activeC==type?'unover':type;
                }
                //console.log("this.activeC",this.activeC)
                if(this.activeC=='over')this.i_over=1;
                if(this.activeC=='unover')this.i_over=0;
                this.getList();
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                ////console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                ////console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                ////console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    ////console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='sou'){
                    this.vc_search=""
                }
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            saveForm(){
                this.backapplys.map(m=>{
                    this.delarr=this.delarr.filter(d=>d!=m.i_pdid)
                })
                //console.log(this.backapplys,'this.backapplys',this.delarr,'this.delarr')
                this.$emit('cancelDialog_fpc',this.backapplys,this.delarr)
            },
            cancel(){
                this.$emit('cancelDialog_fpc');
            },

        }
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table th .el-checkbox{
       display: none !important;
    }

    /deep/.el-table td{
        text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
